module.exports = __webpack_public_path__ + "static/img/pro2.2.11cf0dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/pro2.2.jpg
// module id = 8ThN
// module chunks = 1